import type { CSSProperties } from 'react';

const PEEK_AMOUNT_DESKTOP = 140;
const CARD_WIDTH_PERCENT_DESKTOP = 50;

type UseCardStyleParams = {
  animationDuration: number;
  cardHeight: number;
  containerWidth: number;
  isActive: boolean;
  isMobile: boolean;
  stackPosition: number;
  stackScale: number;
  visibleCardsCount: number;
};

export const useCardStyle = ({
  animationDuration,
  cardHeight,
  containerWidth,
  isActive,
  isMobile,
  stackPosition,
  stackScale,
  visibleCardsCount,
}: UseCardStyleParams): CSSProperties => {
  const cardWidth = (containerWidth * CARD_WIDTH_PERCENT_DESKTOP) / 100;

  const absPosition = Math.abs(stackPosition);
  const scale = Math.pow(stackScale, absPosition);
  const centerLeft = (containerWidth - cardWidth) / 2;

  const left =
    stackPosition > 0
      ? centerLeft + cardWidth - PEEK_AMOUNT_DESKTOP
      : stackPosition < 0
        ? centerLeft - cardWidth + PEEK_AMOUNT_DESKTOP
        : centerLeft;

  const zIndex = 100 - absPosition + (isActive ? 50 : 0);
  const opacity = absPosition <= visibleCardsCount ? 1 : 0;
  const transformOrigin = stackPosition < 0 ? 'right center' : stackPosition > 0 ? 'left center' : 'center center';

  if (isMobile) {
    return {
      height: cardHeight,
      left: 0,
      opacity,
      right: 0,
      top: 16,
      transform: `scale(${scale})`,
      transformOrigin: 'center center',
      transition: `all ${animationDuration}ms cubic-bezier(0.4, 0, 0.2, 1)`,
      willChange: 'transform, opacity',
      zIndex,
    };
  }

  return {
    height: cardHeight,
    left,
    opacity,
    top: 16,
    transform: `scale(${scale})`,
    transformOrigin,
    transition: `all ${animationDuration}ms cubic-bezier(0.4, 0, 0.2, 1)`,
    width: cardWidth,
    willChange: 'transform, opacity, left',
    zIndex,
  };
};
